var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortWorkability2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#010101"
    },
    d: "M385.274,254.656L357.311,18.519C356.221,8.715,347.506,0,336.613,0H168.851 c-10.894,0-19.609,7.626-20.698,18.519l-25.739,237.832c-19.011,8.421-31.997,27.314-31.997,49.76v41.396v142.706 c0,11.983,9.804,21.787,21.787,21.787c10.894,0,20.698-9.804,21.787-21.787V369.294h244.017v120.919 c0,11.983,9.804,21.787,21.787,21.787s21.787-9.804,21.787-21.787V347.506v-41.396 C421.583,282.005,406.608,261.993,385.274,254.656z M132.902,305.021c0-4.885,3.044-9.16,7.31-11.009 c0.813,0.076,1.644,0.115,2.494,0.115h223.319c1.621,0,3.181-0.185,4.672-0.525c4.829,1.551,8.401,6.127,8.401,11.419v20.698 H132.902V305.021z M189.549,42.485h129.634l22.877,209.157H166.672L189.549,42.485z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortWorkability2);
export default __webpack_public_path__ + "static/media/sort-workability2.4e832ce4ae34aa5ec5a6d2bb425d46bf.svg";
export { ForwardRef as ReactComponent };